import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FiHome, FiGrid, FiUsers, FiTruck, FiCalendar, FiSettings, FiShield,
  FiChevronLeft, FiChevronRight
} from 'react-icons/fi';

const AdminSidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
  
  const menuItems = [
    { path: '/admin', label: 'Dashboard', icon: FiHome },
    { path: '/admin/companies', label: 'Companies', icon: FiGrid },
    { path: '/admin/managers', label: 'Managers', icon: FiUsers },
    { path: '/admin/cars', label: 'All Cars', icon: FiTruck },
    { path: '/admin/bookings', label: 'All Bookings', icon: FiCalendar },
    { path: '/admin/verifications', label: 'Document Verifications', icon: FiShield },
    { path: '/admin/settings', label: 'Settings', icon: FiSettings },
  ];
  
  const isActive = (path) => {
    if (path === '/admin') {
      return location.pathname === '/admin';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <aside 
      className={`fixed left-0 top-0 h-full bg-gray-900 text-white transition-all duration-300 z-40 ${
        collapsed ? 'w-16' : 'w-64'
      }`}
    >
      {/* Logo */}
      <div className="h-16 flex items-center justify-between px-4 border-b border-gray-800">
        {!collapsed && (
          <Link to="/admin" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">C</span>
            </div>
            <span className="font-bold text-lg">Admin</span>
          </Link>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 hover:bg-gray-800 rounded-lg transition-colors"
        >
          {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
      </div>
      
      {/* Navigation */}
      <nav className="p-4 space-y-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg transition-colors ${
                active 
                  ? 'bg-primary-600 text-white' 
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`}
              title={collapsed ? item.label : undefined}
            >
              <Icon size={20} />
              {!collapsed && <span className="font-medium">{item.label}</span>}
            </Link>
          );
        })}
      </nav>
      
      {/* Footer */}
      {!collapsed && (
        <div className="absolute bottom-4 left-4 right-4">
          <div className="text-xs text-gray-500 text-center">
            CarBooking Platform
            <br />
            Admin Panel
          </div>
        </div>
      )}
    </aside>
  );
};

export default AdminSidebar;
